























































































import { TicketType } from '../../../api/enums/ticket-type.enum';
import { TicketRequestAction } from '../../../api/enums/ticket-request-action.enum';
import { TicketStatus } from '../../../api/enums/ticket-status.enum';
import {
  TicketTypeDescription,
  TicketStatusDescription,
  TicketStatusColor
} from '../../../api/messages/ticket-request.message';
import { getWordInitials } from '@/utils/getWordInitials';

import { Component } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import AdminService from '@/api/AdminService';
import DateUtils from '@/utils/DateUtils';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    Checkbox,
    Typography,
    FilledButton
  }
})
export default class TicketRequest extends BasePagination {
  limit = 20;
  service: AdminService = new AdminService();
  ticketList: List = new List([], []);
  searchableFields = 'searchableFields=message';
  sortField = '';
  sortOrder = '';
  overviewData: any = {};
  filterValuesSeparator = ':';
  typeFilterModel: any = [];
  statusFilterModel: any = [];

  detailData: any = {};

  created() {
    this.initFilters();

    eventBus.$on('reloadTicketsRequest', this.reload);
    eventBus.$on('setSideModalVisible', (args: any) => {
      if (!args.isOpen) {
        this.reloadList(true, true);
      }
    });
  }

  reload() {
    this.reloadList(true, true, undefined, undefined, (list: any[]) => {
      if (this.detailData) {
        const ticket = list.find(item => item.id === this.detailData.data.id);
        eventBus.$emit('reloadTicketsRequestDetail', ticket);
      }
    });
  }

  initFilters() {
    const typeGroup = new CustomSelectGroup([
      new CustomSelectOption(TicketType.DeleteCustomer, `Delete Customer`)
    ]);

    this.typeFilterModel = new CustomSelectModel(
      [typeGroup],
      `Filter by type`,
      false,
      true,
      true,
      false
    );

    const statusGroup = new CustomSelectGroup([
      new CustomSelectOption(TicketStatus.New, `New`),
      new CustomSelectOption(TicketStatus.Resolved, `Resolved`),
      new CustomSelectOption(TicketStatus.Approved, `Approved`),
      new CustomSelectOption(TicketStatus.Canceled, `Canceled`),
      new CustomSelectOption(TicketStatus.Archived, `Archived`)
    ]);

    this.statusFilterModel = new CustomSelectModel(
      [statusGroup],
      `Filter by status`,
      false,
      true,
      true,
      false
    );
  }

  initHeader() {
    const header = [
      new HeaderList(`Created By`, 'createdBy'),
      new HeaderList(`Type`, 'type'),
      new HeaderList(`Request At`, 'requestedAt'),
      new HeaderList(`Status`, 'status'),
      new HeaderList(`Message`, 'none'),
      new HeaderList(``, 'none', '12px')
    ];
    this.ticketList.header = header;
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean,
    onFinish?: any
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.ticketList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.service
      .getTicketsList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.ticketList.list = this.addRowsToList(items);
        } else {
          this.ticketList.list = this.ticketList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
        if (onFinish) onFinish(this.ticketList.list);
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.refreshing = false;
      });
  }

  formattedRequestedAtVisual(ticket: any) {
    const days = DateUtils.getDifferenceDays(
      ticket.requestedAt,
      new Date().toString()
    );

    if (
      [
        TicketStatus.Approved,
        TicketStatus.Resolved,
        TicketStatus.Canceled,
        TicketStatus.Deleted
      ].includes(ticket.status)
    ) {
      return;
    }

    if (days > 40) {
      return {
        formattedRequestedAtColor: '#c00',
        formattedRequestedAtWeight: '600'
      };
    }

    if (days > 30) {
      return {
        formattedRequestedAtColor: '#c00'
      };
    }

    if (days > 20) {
      return {
        formattedRequestedAtColor: '#e6be1c'
      };
    }
  }

  addRowsToList(tickets: any[]): any[] {
    return tickets.map(ticket => {
      return {
        avatar: getWordInitials(ticket.createdByName),
        typeDescription: this.getTicketTypeDescription(ticket.type),
        statusDescription: this.getTicketStatusDescription(ticket.status),
        statusColor: this.getTicketStatusColor(ticket.status),
        formattedRequestedAt: DateUtils.formattedDate({
          date: ticket.requestedAt,
          format: 'YYYY-MM-DD'
        }),
        ...this.formattedRequestedAtVisual(ticket),
        ...ticket
      };
    });
  }

  async optionSelected(
    action: TicketRequestAction,
    props: Array<any>,
    ticket: any
  ): Promise<void> {
    // set row loading
    const data = {
      id: ticket.id,
      action
    };

    switch (action) {
      case TicketRequestAction.Reply:
        await this.service.replyTicketRequest(data);
        break;
      case TicketRequestAction.Approve:
        await this.service.approveTicketRequest(data);
        break;
      case TicketRequestAction.Cancel:
        await this.service.cancelTicketRequest(data);
        break;
      case TicketRequestAction.Archive:
        await this.service.archiveTicketRequest(data);
        break;
      case TicketRequestAction.Resolve:
        break;
      default:
        break;
    }

    this.reload();
    // set row completed
  }

  // openTicketDetail(event: any) {
  //   const modalConfig = {
  //     isOpen: true,
  //     component: 'adminCoinStoreDetails',
  //     data: event,
  //     width: '750px'
  //   };
  //   this.detailData = modalConfig;
  //   eventBus.$emit('setSideModalVisible', modalConfig);
  // }

  getDeleteCustomerOptions(ticket: any) {
    switch (ticket.status) {
      case TicketStatus.New:
      case TicketStatus.Canceled:
        return [
          {
            label: 'Approve',
            action: TicketRequestAction.Approve
          },
          {
            label: 'Archive',
            action: TicketRequestAction.Archive
          }
        ];

      case TicketStatus.Approved:
        return [
          {
            label: 'Cancel',
            action: TicketRequestAction.Cancel
          }
        ];
    }
  }

  isTicketDisabled(ticket: any) {
    return [TicketStatus.Archived, TicketStatus.Deleted].includes(
      ticket.status
    );
  }

  getTicketTypeDescription(type: TicketType) {
    return TicketTypeDescription[type];
  }

  getTicketStatusDescription(status: TicketStatus) {
    return TicketStatusDescription[status];
  }

  getTicketStatusColor(status: TicketStatus) {
    return TicketStatusColor[status];
  }

  getOptionsByData(ticket: any) {
    if (
      [
        TicketStatus.Resolved,
        TicketStatus.Archived,
        TicketStatus.Deleted
      ].includes(ticket.status)
    ) {
      return [];
    }

    switch (ticket.type) {
      case TicketType.DeleteCustomer:
        return this.getDeleteCustomerOptions(ticket);
    }
  }

  beforeDestroy() {
    eventBus.$off('reloadTicketsRequest', this.reload);
  }

  openNewTicketRequestModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: true,
      component: 'newTicketRequest'
    });
  }
}
